/* yn-kit.js - Yuno motion kit. Ported from the prototype's yuno-kit.js (same drawings, same timings).
   Plain JS, no library, no dependency on any other file (it reads window.Yuno.config if it is already there).
   Exposes window.YK:
     YK.settings, YK.ok(kind)            motion gate: 'answer' (always unless reduced), 'charm' (level 2), 'up' (level 2 with upgrades)
     YK.T, YK.E                          duration and easing tokens
     YK.icon(name, size, fill), YK.ICONS the hand-drawn icon set (same paths as the yn-icon snippet)
     YK.buddy.*, YK.frame.*              the buddy (blink, look, mood, peek, hop ...) and the hand-drawn photo frames (draw, boil ...)
     YK.drawLine, YK.hideLine, YK.pop, YK.press, YK.shake, YK.stamp, YK.boilText, YK.countTo, YK.fly, YK.burst, YK.land
     YK.reveal(root), YK.hydrate(root)   scroll reveal and the automatic setup of every data-yn-* element
   Attributes handled here: data-yn-buddy, data-yn-frame (+ data-yn-seed, data-yn-mat, data-yn-touch-boil="off", data-yn-noreveal),
   data-yn-draw, data-yn-reveal (+ data-yn-stagger), data-yn-icon (+ data-size). Everything is paused off screen and off under reduced motion. */
(function () {
  'use strict';
  var win = window, doc = document;
  var YK = (win.YK = win.YK || {});
  if (YK.ready) return;

  /* ------------------------------------------------------------ settings and the motion gate */
  var mq = win.matchMedia ? win.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var cfg = (win.Yuno && win.Yuno.config) || {};
  YK.settings = { level: cfg.upgrades === false ? '2' : '2+', reduced: !!mq.matches };
  YK.setUpgrades = function (on) { YK.settings.level = on === false ? '2' : '2+'; };
  if (mq.addEventListener) mq.addEventListener('change', function (e) { YK.settings.reduced = e.matches; });
  else if (mq.addListener) mq.addListener(function (e) { YK.settings.reduced = e.matches; });
  // kind: 'answer' (always unless reduced), 'charm' (level >= 2), 'up' (level 2 + upgrades)
  YK.ok = function (kind) {
    var s = YK.settings;
    if (s.reduced) return false;
    if (kind === 'answer') return true;
    if (kind === 'charm') return s.level !== '1';
    if (kind === 'up') return s.level === '2+';
    return true;
  };
  YK.T = { instant: 100, quick: 180, base: 260, sheet: 340, draw: 500, story: 800 };
  YK.E = { out: 'cubic-bezier(.2,.8,.2,1)', 'in': 'cubic-bezier(.4,0,1,1)', spring: 'cubic-bezier(.3,1.4,.5,1)', linear: 'linear' };

  /* ------------------------------------------------------------ small helpers */
  function qa(root, sel) {
    var out = [];
    if (!root) return out;
    if (root.nodeType === 1 && root.matches && root.matches(sel)) out.push(root);
    if (root.querySelectorAll) { var l = root.querySelectorAll(sel); for (var i = 0; i < l.length; i++) out.push(l[i]); }
    return out;
  }
  function animate(el, frames, opts) {
    if (!el || !el.animate) return null;
    try { return el.animate(frames, opts); } catch (e) { return null; }
  }
  function done(anim) { return anim && anim.finished ? anim.finished.then(function () {}, function () {}) : Promise.resolve(); }
  var designMode = !!(win.Shopify && win.Shopify.designMode) || !!cfg.designMode;

  /* ------------------------------------------------------------ icons: 24px grid, 2px stroke, round caps, slightly off-straight */
  var IC = (YK.ICONS = {
    cart: 'M5.2 8.4l13.6-.1-1 11.4c-.1.7-.6 1.2-1.3 1.2H7.5c-.7 0-1.2-.5-1.3-1.2zM9 8.3V6.8c0-1.8 1.3-3.1 3-3.1s3 1.3 3 3.1v1.5',
    search: 'M10.6 4.2c3.6-.1 6.4 2.8 6.3 6.3-.1 3.5-3 6.2-6.5 6.1-3.4-.1-6.2-3-6.1-6.4.1-3.3 2.9-6 6.3-6zM15.4 15.6l4.6 4.6',
    menu: 'M4 7c3-.6 6 .4 9-.1s5-.3 7 .1M4 12.1c3 .5 6-.4 9 .1s5 .2 7-.2M4 17c3-.4 6 .5 9 0s5-.3 7 .1',
    close: 'M6.2 6.2c4 3.8 7.9 7.8 11.7 11.7M17.9 6.1c-4 4-7.9 7.8-11.8 11.8',
    account: 'M12 4.6c2 0 3.6 1.6 3.6 3.6s-1.6 3.7-3.6 3.6c-2 0-3.6-1.6-3.6-3.6S10 4.6 12 4.6zM5 20c.6-3.7 3.4-5.8 7-5.8s6.4 2.1 7 5.8',
    arrow: 'M4 12.2c5-.3 10 .2 15-.1M13.5 6.6c2 2 3.8 3.7 5.6 5.5-1.9 1.9-3.6 3.7-5.6 5.6',
    'arrow-back': 'M20 12.2c-5-.3-10 .2-15-.1M10.5 6.6c-2 2-3.8 3.7-5.6 5.5 1.9 1.9 3.6 3.7 5.6 5.6',
    chevron: 'M6.5 9.5c1.9 1.8 3.7 3.6 5.5 5.4 1.8-1.8 3.6-3.6 5.5-5.4',
    tick: 'M5 12.6c1.6 1.4 3 2.8 4.4 4.3C12 13 15 9.4 19.2 6.2',
    plus: 'M12 5.2c.1 4.6-.1 9.1 0 13.6M5.2 12.1c4.6-.1 9.1.1 13.6-.1',
    minus: 'M5.2 12.1c4.6-.1 9.1.1 13.6-.1',
    bin: 'M5 7.1l14-.1M9.5 7V5.1l5-.1v2M6.5 7.1l.9 12.2c0 .7.6 1.2 1.3 1.2h6.6c.7 0 1.2-.5 1.3-1.2l.9-12.2',
    ruler: 'M3.8 15.6L15.6 3.8l4.6 4.7L8.5 20.2zM8 11.3l1.8 1.8M10.6 8.7l1.3 1.3M13.2 6.1L15 7.9',
    truck: 'M3.5 7.1l10-.1v9h-10zM13.5 10h3.8l3.2 3.3V16h-7M7 16.6c.9 0 1.6.7 1.6 1.6S7.9 19.8 7 19.8s-1.6-.7-1.6-1.6.7-1.6 1.6-1.6zM17 16.6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6-1.6-.7-1.6-1.6.7-1.6 1.6-1.6z',
    card: 'M3.5 6.6l17-.1v11.2l-17 .1zM3.6 10.4c5.6.2 11.2-.1 16.8.1M6.8 14.6h3.2',
    cash: 'M3.5 7.1l17-.1v10h-17zM12 9.6c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4-2.4-1.1-2.4-2.4 1.1-2.4 2.4-2.4zM6.3 9.6v.1M17.7 14.4v.1',
    exchange: 'M5 9.1l12.5-.1-3-3M19 15l-12.5.1 3 3',
    whatsapp: 'M12 4c4.6 0 8.2 3.3 8.1 7.6-.1 4.2-3.7 7.5-8.2 7.4-1.2 0-2.3-.2-3.3-.6l-4.3 1.4 1.3-3.9C4.6 14.6 4 13.1 4 11.5 4.1 7.3 7.5 4 12 4zM9 9.4c.3 2.5 2.3 4.6 5.4 5.3',
    phone: 'M6.6 4.2l2.6-.4 1.4 3.6-1.7 1.3c.9 2.1 2.4 3.7 4.5 4.6l1.3-1.7 3.6 1.4-.4 2.7c-.2 1-1 1.6-2 1.5-5.5-.6-8.5-3.6-10.9-9-.1-1 .5-1.8 1.6-4z',
    mail: 'M4 6.6l16-.1v11H4zM4.3 6.9l7.7 6.2 7.7-6.3',
    instagram: 'M7.6 3.8h8.8c2 0 3.8 1.7 3.8 3.8v8.8c0 2-1.7 3.8-3.8 3.8H7.6c-2 0-3.8-1.7-3.8-3.8V7.6c0-2.1 1.7-3.8 3.8-3.8zM12 8.5c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5 1.6-3.5 3.5-3.5zM16.9 7.2v.1',
    facebook: 'M17.6 4.2h-1.5c-2 0-3.3 1.3-3.3 3.3V20M9.2 11.4h7.2',
    tiktok: 'M14 4v10.2c0 2-1.6 3.6-3.6 3.6S6.8 16.2 6.8 14.2s1.6-3.6 3.6-3.6M14 4c.3 2.4 1.8 3.9 4.2 4.1',
    leaf: 'M5 19c0-8 5-13.5 14.5-14-.3 9.7-6 14.6-14 14zM5 19c3.2-4 6-6.6 9.5-9',
    tee: 'M8.5 4.5L3.8 7.1l1.8 3.8 2.2-.9v10h8.4V10l2.2.9 1.8-3.8-4.7-2.6c-.6 1.4-1.8 2.2-3.5 2.2S9.1 5.9 8.5 4.5z',
    heart: 'M12 19.5c-4.5-3-8-6-8-9.6C4 7.4 5.8 5.5 8 5.5c1.7 0 3 .9 4 2.4 1-1.5 2.3-2.4 4-2.4 2.2 0 4 1.9 4 4.4 0 3.6-3.5 6.6-8 9.6z',
    wash: 'M3.5 11.1l17-.1c-.3 4.6-3.5 7.6-8.5 7.6S3.8 15.6 3.5 11.1zM7 18l-1 2.2M17 18l1 2.2M8 8.2c.6-1 .6-2-.1-3M12 8.2c.6-1 .6-2-.1-3M16 8.2c.6-1 .6-2-.1-3',
    flame: 'M12 3.5c.8 3 3.9 4.6 4.6 8.1.7 3.7-1.8 7.6-4.6 7.9-3.2.3-5.6-2.3-5.4-5.4.1-1.8 1-3 2-3.9.2 1.6.9 2.6 1.9 2.9-.5-3.1.5-6.4 1.5-9.6z',
    star: 'M12 3.4l2.6 5.4 5.8.8-4.3 4 1.1 5.8L12 16.6l-5.2 2.8 1.1-5.8-4.3-4 5.8-.8z',
    filter: 'M4 7.1l16-.1M7 12.1l10-.1M10 17h4',
    share: 'M12 14.8V4.2M8.2 7.8L12 4l3.8 3.8M6 11.4v6.4c0 .9.6 1.5 1.5 1.5h9c.9 0 1.5-.6 1.5-1.5v-6.4',
    zoom: 'M10.6 4.2c3.6-.1 6.4 2.8 6.3 6.3-.1 3.5-3 6.2-6.5 6.1-3.4-.1-6.2-3-6.1-6.4.1-3.3 2.9-6 6.3-6zM15.4 15.6l4.6 4.6M8.2 10.5h4.4M10.4 8.3v4.4',
    shop: 'M4 9.5l1.4-4.8h13.2L20 9.5M4 9.5c0 1.5 1.1 2.4 2.7 2.4 1.4 0 2.3-.9 2.6-2.4.3 1.5 1.2 2.4 2.7 2.4s2.4-.9 2.7-2.4c.3 1.5 1.3 2.4 2.6 2.4 1.6 0 2.7-.9 2.7-2.4M5.6 11.9v7.5h12.8v-7.5M10 19.4v-4.2h4v4.2',
    back: 'M20 12.2c-5-.3-10 .2-15-.1M10.5 6.6c-2 2-3.8 3.7-5.6 5.5 1.9 1.9 3.6 3.7 5.6 5.6',
    chat: 'M12 4c4.6 0 8.2 3.3 8.1 7.6-.1 4.2-3.7 7.5-8.2 7.4-1.2 0-2.3-.2-3.3-.6l-4.3 1.4 1.3-3.9C4.6 14.6 4 13.1 4 11.5 4.1 7.3 7.5 4 12 4zM9 9.4c.3 2.5 2.3 4.6 5.4 5.3',
    check: 'M5 12.6c1.6 1.4 3 2.8 4.4 4.3C12 13 15 9.4 19.2 6.2',
    tub: 'M3.5 11.1l17-.1c-.3 4.6-3.5 7.6-8.5 7.6S3.8 15.6 3.5 11.1zM7 18l-1 2.2M17 18l1 2.2M8 8.2c.6-1 .6-2-.1-3M12 8.2c.6-1 .6-2-.1-3M16 8.2c.6-1 .6-2-.1-3',
    x: 'M6.2 6.2c4 3.8 7.9 7.8 11.7 11.7M17.9 6.1c-4 4-7.9 7.8-11.8 11.8'
  });
  YK.icon = function (name, size, fill) {
    var d = IC[name] || '';
    var filled = name === 'star' || fill;
    var s = size || 24;
    return '<svg class="yn-icon" viewBox="0 0 24 24" width="' + s + '" height="' + s + '" aria-hidden="true" focusable="false" fill="' + (filled ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="' + (filled ? 1.2 : 2) + '" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  };

  /* ------------------------------------------------------------ the buddy (same drawing as the yn-buddy snippet) */
  var BODY = 'M1156.33,259.24v371.35c0,15.15-7.59,22.72-22.77,22.72h-138.17c-15.18,0-23.54-7.57-25.05-22.72l-3.8-33.34c-.75-9.09-4.56-13.63-12.9-13.63-9.11,0-12.92,5.3-16.71,12.12-21.26,34.09-56.93,65.15-117.67,65.15-99.45,0-127.53-53.79-127.53-121.97v-279.68c0-15.15,7.6-22.73,22.78-22.73h167.01c15.18,0,22.78,7.58,22.78,22.73v161.76c0,18.93,8.34,30.3,21.24,30.3,15.95,0,24.3-15.16,24.3-34.85v-157.21c0-15.15,7.59-22.73,22.77-22.73h160.95c15.18,0,22.77,7.58,22.77,22.73Z';
  var LEG_L = 'M825.2,549.04c-12.12,155.87-9.18,158.77-15.25,164.06-8.24,7.48-49.67-.84-104.58,33.1-31.09,19.59-38.08,43.69-33.27,61.38,8,27.9,41.27,33.81,66.51,35.36,68.04,4.08,161.57.32,150.37-66.92-8.3-55.58-47.52-40.27-20.33-203.18l-43.45-23.81Z';
  var LEG_R = 'M1048.96,549.04c12.12,155.87,9.18,158.77,15.25,164.06,8.24,7.48,49.67-.84,104.58,33.1,31.09,19.59,38.08,43.69,33.27,61.38-8,27.9-41.27,33.81-66.51,35.36-68.04,4.08-161.57.32-150.37-66.92,8.3-55.58,47.52-40.27,20.33-203.18l43.45-23.81Z';
  function EYE(cx) { return 'M' + (cx + 65.58) + ',373.6c0,41.48-29.36,75.1-65.59,75.1s-65.58-33.62-65.58-75.1c0-2.84.14-5.65.41-8.4,3.65-37.53,31.44-66.7,65.17-66.7s58.94,26.52,64.51,61.52c.71,4.4,1.07,8.95,1.07,13.58Z'; }
  var BUDDY_COLORS = { blue: '#0040ea', yellow: '#fece00', pink: '#f49ac1', orange: '#ff6a1a', green: '#1f9a5b' };
  YK.buddySVG = function (color, legs) {
    var c = BUDDY_COLORS[color] || color || '#0040ea';
    var L = 803.59, R = 1059.24;
    var pupil = c === '#fece00' ? '#1f2a44' : c;
    var eye = function (cx, side) {
      return '<g data-b="eye' + side + '" style="transform-box:fill-box;transform-origin:center"><path fill="#fff" d="' + EYE(cx) + '"/><ellipse data-b="pupil' + side + '" cx="' + cx + '" cy="373.6" rx="33.77" ry="32.65" fill="' + pupil + '"/></g>';
    };
    var happy = function (cx) { return '<path d="M' + (cx - 46) + ',392 Q' + cx + ',322 ' + (cx + 46) + ',392" fill="none" stroke="#fff" stroke-width="24" stroke-linecap="round"/>'; };
    var lid = function (cx) {
      return '<path d="M' + (cx - 72) + ',290 H' + (cx + 72) + ' V372 Q' + cx + ',392 ' + (cx - 72) + ',372 Z" fill="' + c + '"/>' +
        '<path d="M' + (cx - 58) + ',372 Q' + cx + ',392 ' + (cx + 58) + ',372" fill="none" stroke="#1f2a44" stroke-opacity=".35" stroke-width="8" stroke-linecap="round"/>';
    };
    var legsSvg = legs ? '<path fill="' + c + '" d="' + LEG_L + '"/><path fill="' + c + '" d="' + LEG_R + '"/>' : '';
    return '<svg viewBox="' + (legs ? '630 216 610 650' : '630 216 547 476') + '" width="100%" aria-hidden="true" focusable="false" style="display:block;overflow:visible">' +
      '<g data-b="all" style="transform-box:fill-box;transform-origin:50% 100%">' + legsSvg + '<path fill="' + c + '" d="' + BODY + '"/>' + eye(L, 'L') + eye(R, 'R') +
      '<g data-b="happy" style="opacity:0">' + happy(L) + happy(R) + '</g><g data-b="lids" style="opacity:0">' + lid(L) + lid(R) + '</g></g></svg>';
  };

  var B = (YK.buddy = {});
  var buddies = [];                 // mounted buddies
  var lookAtPointT = null;
  function part(host, k) { return host.querySelector('[data-b="' + k + '"]'); }
  function isSvg(el) { return el.localName === 'svg' && el.namespaceURI === 'http://www.w3.org/2000/svg'; }
  function visibleBuddies() { return buddies.filter(function (h) { return h.isConnected && h.__yk && h.__yk.visible && !h.__yk.busy; }); }
  function setPupil(el, from, to, dur) {
    if (!el) return;
    if (el.__a) { try { el.__a.cancel(); } catch (e) {} el.__a = null; }
    el.style.transform = to;
    if (!dur || !YK.ok('answer')) return;
    el.__a = animate(el, [{ transform: from }, { transform: to }], { duration: dur, easing: YK.E.out });
  }
  function loops(host) {
    var st = host.__yk;
    st.timers.forEach(clearTimeout);
    st.timers = [];
    if (!st.visible || doc.hidden || !host.isConnected || YK.settings.reduced) return;
    (function blinkLoop() {
      st.timers.push(setTimeout(function () {
        if (!host.isConnected) return B.unmount(host);
        if (st.visible && !doc.hidden && YK.ok('answer')) B.blink(host);
        blinkLoop();
      }, 4000 + Math.random() * 3000));
    })();
    (function driftLoop() {
      st.timers.push(setTimeout(function () {
        if (!host.isConnected) return B.unmount(host);
        if (st.visible && !doc.hidden && YK.ok('charm') && !st.busy && !st.pointer) B.look(host, (Math.random() - 0.5) * 22, (Math.random() - 0.5) * 12, 600);
        driftLoop();
      }, 2600 + Math.random() * 2400));
    })();
  }
  B.mount = function (host) {
    if (host.__yk) return host.__yk;
    if (!isSvg(host) && !part(host, 'all')) host.innerHTML = YK.buddySVG(host.getAttribute('data-yn-buddy'), host.hasAttribute('data-legs'));
    var st = (host.__yk = { look: [0, 0], visible: false, busy: false, pointer: false, timers: [] });
    buddies.push(host);
    if ('IntersectionObserver' in win) {
      st.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { st.visible = e.isIntersecting; });
        loops(host);
      });
      st.io.observe(host);
    } else { st.visible = true; loops(host); }
    var mood = host.getAttribute('data-mood');
    if (mood === 'sleepy') B.sleepy(host, true);
    else if (mood === 'happy') B.state(host, 'happy');
    host.addEventListener('click', function () { if (!host.closest('a,button')) B.poke(host); });
    listen();
    return st;
  };
  B.unmount = function (host) {
    var st = host.__yk; if (!st) return;
    st.timers.forEach(clearTimeout);
    if (st.io) st.io.disconnect();
    buddies = buddies.filter(function (h) { return h !== host; });
    host.__yk = null;
  };
  B.blink = function (host) {
    if (!YK.ok('answer')) return;
    ['eyeL', 'eyeR'].forEach(function (k) { animate(part(host, k), [{ transform: 'scaleY(1)' }, { transform: 'scaleY(.1)' }, { transform: 'scaleY(1)' }], { duration: 160, easing: 'ease-in-out' }); });
  };
  B.look = function (host, dx, dy, dur) {
    var st = host.__yk; if (!st) return;
    var from = 'translate(' + st.look[0] + 'px,' + st.look[1] + 'px)', to = 'translate(' + dx + 'px,' + dy + 'px)';
    st.look = [dx, dy];
    setPupil(part(host, 'pupilL'), from, to, YK.settings.reduced ? 0 : dur || 260);
    setPupil(part(host, 'pupilR'), from, to, YK.settings.reduced ? 0 : dur || 260);
  };
  B.lookAt = function (host, el) { // point with the eyes toward an element
    if (!host.__yk) return;
    var a = host.getBoundingClientRect(), b = el.getBoundingClientRect();
    B.lookAtPoint(host, b.left + b.width / 2, b.top + b.height / 2, 320, a);
  };
  B.lookAtPoint = function (host, x, y, dur, rect) {
    var a = rect || host.getBoundingClientRect();
    var dx = x - (a.left + a.width / 2), dy = y - (a.top + a.height * 0.35);
    var m = Math.hypot(dx, dy) || 1;
    B.look(host, (dx / m) * 22, (dy / m) * 14, dur || 260);
  };
  B.state = function (host, mood) { // 'happy' | 'sleepy' | null
    var h = part(host, 'happy'), l = part(host, 'lids'), eL = part(host, 'eyeL'), eR = part(host, 'eyeR');
    if (!h) return;
    h.style.opacity = mood === 'happy' ? 1 : 0;
    l.style.opacity = mood === 'sleepy' ? 1 : 0;
    [eL, eR].forEach(function (e) { if (e) e.style.opacity = mood === 'happy' ? 0 : 1; });
  };
  B.poke = function (host) {
    if (!YK.ok('answer')) { return; }
    var all = part(host, 'all'); if (!all) return;
    animate(all, [{ transform: 'rotate(0)' }, { transform: 'rotate(-6deg)' }, { transform: 'rotate(5deg)' }, { transform: 'rotate(-3deg)' }, { transform: 'rotate(0)' }], { duration: 520, easing: YK.E.out });
    ['eyeL', 'eyeR'].forEach(function (k) { animate(part(host, k), [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 520, easing: YK.E.spring }); });
  };
  B.hop = function (host) {
    B.state(host, 'happy');
    setTimeout(function () { B.state(host, null); }, 900);
    if (!YK.ok('charm')) return;
    animate(part(host, 'all'), [
      { transform: 'translateY(0) scale(1,1)' }, { transform: 'translateY(0) scale(1.08,.9)', offset: 0.18 },
      { transform: 'translateY(-60px) scale(.95,1.06)', offset: 0.5 }, { transform: 'translateY(0) scale(1.06,.94)', offset: 0.82 }, { transform: 'translateY(0) scale(1,1)' }
    ], { duration: 620, easing: 'ease-out' });
  };
  B.peek = function (host, opts) {
    opts = opts || {};
    var from = opts.from || 'bottom';
    var off = from === 'bottom' ? 'translateY(105%)' : from === 'start' ? 'translateX(-105%)' : 'translateX(105%)';
    if (!YK.ok('charm')) { host.style.transform = opts.rest || 'none'; return Promise.resolve(); }
    var a = animate(host, [{ transform: off + ' rotate(0deg)' }, { transform: (opts.rest || 'translateY(0)') + ' rotate(' + (opts.tilt == null ? -6 : opts.tilt) + 'deg)' }], { duration: 520, delay: opts.delay || 0, easing: YK.E.spring, fill: 'both' });
    return done(a);
  };
  B.sleepy = function (host, on) {
    B.state(host, on ? 'sleepy' : null);
    var all = part(host, 'all'); if (!all) return;
    if (host.__sway) { host.__sway.cancel(); host.__sway = null; }
    if (on && YK.ok('charm')) host.__sway = animate(all, [{ transform: 'rotate(-3deg)' }, { transform: 'rotate(3deg)' }], { duration: 2200, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
  };
  B.searching = function (host, on) { // slow-content state: eyes side to side
    if (host.__srch) { host.__srch.forEach(function (a) { a.cancel(); }); host.__srch = null; }
    if (!on || YK.settings.reduced) return;
    host.__srch = ['pupilL', 'pupilR'].map(function (k) { return animate(part(host, k), [{ transform: 'translate(-22px,0)' }, { transform: 'translate(22px,0)' }], { duration: 700, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' }); }).filter(Boolean);
  };

  /* the buddy follows the last touch, the pointer and the scroll direction (level 2; paused off screen) */
  var listening = false;
  function listen() {
    if (listening) return; listening = true;
    function eyes(x, y, hold) {
      if (!YK.ok('charm')) return;
      visibleBuddies().forEach(function (h) {
        var st = h.__yk;
        st.pointer = true;
        B.lookAtPoint(h, x, y, 220);
        clearTimeout(st.pointerT);
        st.pointerT = setTimeout(function () { st.pointer = false; B.look(h, 0, 0, 400); }, hold);
      });
    }
    doc.addEventListener('pointerdown', function (e) { if (buddies.length) eyes(e.clientX, e.clientY, 1400); }, { capture: true, passive: true });
    var moveRaf = 0, mx = 0, my = 0;
    doc.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !buddies.length) return;
      mx = e.clientX; my = e.clientY;
      if (moveRaf) return;
      moveRaf = requestAnimationFrame(function () { moveRaf = 0; eyes(mx, my, 1800); });
    }, { passive: true });
    var lastY = win.pageYOffset, dir = 0, ticking = false, settleT = 0;
    win.addEventListener('scroll', function () {
      if (ticking || !buddies.length) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = win.pageYOffset, dy = y - lastY; lastY = y;
        if (!YK.ok('charm') || Math.abs(dy) < 2) return;
        var d = dy > 0 ? 1 : -1;
        if (d !== dir) { dir = d; visibleBuddies().forEach(function (h) { if (!h.__yk.pointer) B.look(h, 0, d * 16, 220); }); }
        clearTimeout(settleT);
        settleT = setTimeout(function () { dir = 0; visibleBuddies().forEach(function (h) { if (!h.__yk.pointer) B.look(h, 0, 0, 400); }); }, 220);
      });
    }, { passive: true });
    doc.addEventListener('visibilitychange', function () { buddies.forEach(function (h) { if (h.__yk) loops(h); }); });
  }

  /* ------------------------------------------------------------ hand-drawn frames: 5 kinds x 3 boil versions; the mat (photo cut) never boils */
  function rng(seed) { var s = (seed * 9301 + 49297) % 233280; return function () { return (s = (s * 9301 + 49297) % 233280) / 233280; }; }
  function perim(w, h, r, inset, n) {
    var x0 = inset, y0 = inset, x1 = w - inset, y1 = h - inset;
    r = Math.min(r, (x1 - x0) / 2, (y1 - y0) / 2);
    var ew = x1 - x0 - 2 * r, eh = y1 - y0 - 2 * r, arc = (Math.PI * r) / 2;
    var parts = [
      { len: ew, f: function (u) { return [x0 + r + u * ew, y0, 0, -1]; } },
      { len: arc, f: function (u) { var a = -Math.PI / 2 + (u * Math.PI) / 2; return [x1 - r + r * Math.cos(a), y0 + r + r * Math.sin(a), Math.cos(a), Math.sin(a)]; } },
      { len: eh, f: function (u) { return [x1, y0 + r + u * eh, 1, 0]; } },
      { len: arc, f: function (u) { var a = (u * Math.PI) / 2; return [x1 - r + r * Math.cos(a), y1 - r + r * Math.sin(a), Math.cos(a), Math.sin(a)]; } },
      { len: ew, f: function (u) { return [x1 - r - u * ew, y1, 0, 1]; } },
      { len: arc, f: function (u) { var a = Math.PI / 2 + (u * Math.PI) / 2; return [x0 + r + r * Math.cos(a), y1 - r + r * Math.sin(a), Math.cos(a), Math.sin(a)]; } },
      { len: eh, f: function (u) { return [x0, y1 - r - u * eh, -1, 0]; } },
      { len: arc, f: function (u) { var a = Math.PI + (u * Math.PI) / 2; return [x0 + r + r * Math.cos(a), y0 + r + r * Math.sin(a), Math.cos(a), Math.sin(a)]; } }
    ];
    var L = parts.reduce(function (a, p) { return a + p.len; }, 0), pts = [];
    for (var i = 0; i < n; i++) {
      var d = (i / n) * L, k = 0;
      while (k < parts.length - 1 && d > parts[k].len) { d -= parts[k].len; k++; }
      var q = parts[k].f(parts[k].len ? Math.min(1, d / parts[k].len) : 0);
      pts.push({ x: q[0], y: q[1], nx: q[2], ny: q[3], t: i / n });
    }
    return { pts: pts, L: L };
  }
  function noiseFn(seed, amp) {
    var r = rng(seed), f1 = 3 + Math.floor(r() * 3), f2 = 9 + Math.floor(r() * 5), p1 = r() * 6.28, p2 = r() * 6.28;
    return function (t) { return amp * (0.7 * Math.sin(6.283 * f1 * t + p1) + 0.3 * Math.sin(6.283 * f2 * t + p2)); };
  }
  function smooth(pts) {
    var m = function (a, b) { return [((a[0] + b[0]) / 2).toFixed(1), ((a[1] + b[1]) / 2).toFixed(1)]; };
    var d = 'M' + m(pts[pts.length - 1], pts[0]).join(' ');
    for (var i = 0; i < pts.length; i++) { var a = pts[i], b = pts[(i + 1) % pts.length]; d += 'Q' + a[0].toFixed(1) + ' ' + a[1].toFixed(1) + ' ' + m(a, b).join(' '); }
    return d + 'Z';
  }
  function poly(pts) { return 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join('L') + 'Z'; }
  var FRAME = {
    crayon: { color: '#fece00', width: 3.6, inset: 4, amp: 1.3 },
    scallop: { color: '#0040ea', width: 3, inset: 5, amp: 0.6 },
    zigzag: { color: '#f49ac1', width: 3, inset: 5, amp: 0.6 },
    dots: { color: '#1f9a5b', width: 5, inset: 5, amp: 1.0 },
    marker: { color: '#ff6a1a', width: 4.6, inset: 4, amp: 1.7 }
  };
  YK.FRAME_KINDS = Object.keys(FRAME);
  function framePaths(kind, w, h, seed, v) {
    var K = FRAME[kind], r = 16;
    var n = Math.max(120, Math.round((2 * (w + h)) / 3));
    var pts = perim(w, h, r, K.inset, n).pts;
    var base = noiseFn(seed, K.amp), jit = noiseFn(seed * 7 + v * 31 + 3, v ? 0.75 : 0);
    var per = 2 * (w + h);
    var disp = function (p) {
      var d = base(p.t) + jit(p.t);
      if (kind === 'scallop') { var k = Math.round(per / 20); d += 3.2 * Math.abs(Math.sin(Math.PI * k * p.t)) - 1.6; }
      if (kind === 'zigzag') { var kz = Math.round(per / 11); var ph = (p.t * kz) % 1; d += (ph < 0.5 ? ph * 4 - 1 : 3 - ph * 4) * 2.4; }
      return d;
    };
    var mk = function (extra) { return pts.map(function (p) { var d = disp(p) + (extra || 0); return [p.x + p.nx * d, p.y + p.ny * d]; }); };
    var line = kind === 'zigzag' ? poly(mk()) : smooth(mk());
    var lines = [line];
    if (kind === 'crayon') { var j2 = noiseFn(seed * 3 + v * 13 + 1, 1.1); lines.push(smooth(pts.map(function (p) { var d = base(p.t) * 0.4 + j2(p.t) - 3.4; return [p.x + p.nx * d, p.y + p.ny * d]; }))); }
    return lines;
  }
  function matPath(kind, w, h, seed) {
    var K = FRAME[kind], pts = perim(w, h, 16, K.inset + 0.5, 120).pts, base = noiseFn(seed, K.amp);
    return 'M0 0H' + w + 'V' + h + 'H0Z' + smooth(pts.map(function (p) { var d = base(p.t); return [p.x + p.nx * d, p.y + p.ny * d]; }));
  }
  function matColour(host) { // the first solid colour behind the photo, so the cut matches the section
    for (var el = host.parentElement; el && el !== doc.documentElement; el = el.parentElement) {
      var bg = win.getComputedStyle(el).backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)) return bg;
    }
    return '#fbf9f5';
  }
  var frameCount = 0;
  var F = (YK.frame = {});
  F.layer = function (host) {
    if (!host.__layer) {
      var l = doc.createElement('span');
      l.className = 'yn-frame-layer';
      l.setAttribute('aria-hidden', 'true');
      host.appendChild(l);
      host.__layer = l;
    }
    return host.__layer;
  };
  F.render = function (host) {
    var kind = host.getAttribute('data-yn-frame'), K = FRAME[kind]; if (!K) return;
    var w = Math.round(host.clientWidth), h = Math.round(host.clientHeight); if (!w || !h) return;
    var seed = +(host.getAttribute('data-yn-seed') || host.__seed || 1);
    var mat = host.getAttribute('data-yn-mat') || host.__mat || '#fbf9f5';
    var dash = kind === 'dots' ? ' stroke-dasharray="0 9"' : '';
    var g = '';
    for (var v = 0; v < 3; v++) {
      g += '<g data-v="' + v + '" style="opacity:' + (v === 0 ? 1 : 0) + '">' + framePaths(kind, w, h, seed, v).map(function (d, i) {
        return '<path d="' + d + '" fill="none" stroke="' + K.color + '" stroke-width="' + (i ? K.width * 0.6 : K.width) + '" stroke-linecap="round" stroke-linejoin="round"' + dash + '/>';
      }).join('') + '</g>';
    }
    var stars = '';
    if (kind === 'marker') {
      var s = function (cx, cy, R) { var p = []; for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + (i * Math.PI) / 5, rr = i % 2 ? R * 0.45 : R; p.push([cx + rr * Math.cos(a), cy + rr * Math.sin(a)]); } return '<path d="' + poly(p) + '" fill="' + K.color + '"/>'; };
      stars = '<g data-stars>' + s(w - 12, 10, 8) + s(w - 28, 4, 5) + '</g>';
    }
    F.layer(host).innerHTML = '<svg width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '" aria-hidden="true" focusable="false" style="position:absolute;inset:0;overflow:visible;pointer-events:none"><path d="' + matPath(kind, w, h, seed) + '" fill="' + mat + '" fill-rule="evenodd"/>' + g + stars + '</svg>';
    host.__w = w; host.__h = h;
    if (host.__drawn === false) F.hide(host);
  };
  F.mount = function (host) {
    if (host.__ykf) return; host.__ykf = true;
    host.__seed = (++frameCount * 3) % 11 + 1;
    host.__mat = matColour(host);
    F.render(host);
    if ('ResizeObserver' in win) new ResizeObserver(function () { if (host.clientWidth !== host.__w || host.clientHeight !== host.__h) F.render(host); }).observe(host);
    if (host.getAttribute('data-yn-touch-boil') !== 'off') host.addEventListener('pointerdown', function () { F.boil(host, 600); }, { passive: true });
  };
  F.hide = function (host) {
    host.__drawn = false;
    host.querySelectorAll('g[data-v] path').forEach(function (p) { p.setAttribute('pathLength', '1'); p.style.strokeDasharray = '1 1'; p.style.strokeDashoffset = '1'; });
    var s = host.querySelector('[data-stars]'); if (s) s.style.opacity = 0;
  };
  F.draw = function (host, delay) {
    host.__drawn = true;
    var paths = host.querySelectorAll('g[data-v="0"] path'), dots = host.getAttribute('data-yn-frame') === 'dots';
    var s = host.querySelector('[data-stars]');
    if (!YK.ok('charm')) {
      host.querySelectorAll('g[data-v] path').forEach(function (p) { p.style.strokeDasharray = dots ? '0 9' : 'none'; p.style.strokeDashoffset = '0'; });
      if (s) s.style.opacity = 1;
      return;
    }
    paths.forEach(function (p) {
      if (dots) { p.removeAttribute('pathLength'); p.style.strokeDasharray = '0 9'; p.style.strokeDashoffset = 0; animate(p, [{ opacity: 0 }, { opacity: 1 }], { duration: YK.T.draw, delay: delay || 0, easing: YK.E.out, fill: 'backwards' }); return; }
      animate(p, [{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], { duration: YK.T.draw + 200, delay: delay || 0, easing: YK.E.out, fill: 'forwards' });
    });
    setTimeout(function () {
      host.querySelectorAll('g[data-v] path').forEach(function (p) {
        if (!dots) { p.style.strokeDasharray = 'none'; p.style.strokeDashoffset = '0'; } else { p.removeAttribute('pathLength'); p.style.strokeDasharray = '0 9'; }
      });
    }, (delay || 0) + YK.T.draw + 260);
    if (s) animate(s, [{ opacity: 0, transform: 'scale(.4)' }, { opacity: 1, transform: 'scale(1)' }], { duration: YK.T.quick, delay: (delay || 0) + YK.T.draw, easing: YK.E.spring, fill: 'both' });
  };
  F.step = function (host, v) { host.querySelectorAll('g[data-v]').forEach(function (g) { g.style.opacity = +g.getAttribute('data-v') === v ? 1 : 0; }); };
  F.boil = function (host, ms) { // 8 fps, stepped, no blending
    if (!YK.ok('charm') || host.__drawn === false) return;
    clearInterval(host.__boil);
    var i = 0, end = Date.now() + (ms || 700);
    host.__boil = setInterval(function () {
      i = (i + 1) % 3; F.step(host, i);
      if (Date.now() > end || !host.isConnected) { clearInterval(host.__boil); F.step(host, 0); }
    }, 125);
  };
  F.loop = function (host, on) {
    clearInterval(host.__loop);
    if (!on || !YK.ok('charm')) { F.step(host, 0); return; }
    var i = 0;
    host.__loop = setInterval(function () { i = (i + 1) % 3; F.step(host, i); }, 140);
  };

  /* ------------------------------------------------------------ small motion helpers */
  YK.drawLine = function (el, delay) { // squiggle draw-on
    if (!el) return;
    var p = el.localName === 'path' ? el : el.querySelector('path'); if (!p) return;
    var host = el.closest ? el.closest('[data-yn-draw]') : null;
    if (host) { if (host.__ynDr) return; host.__ynDr = true; }   // once per hideLine
    p.setAttribute('pathLength', '1');
    if (!YK.ok('charm')) { p.style.strokeDasharray = 'none'; p.style.strokeDashoffset = 0; if (host) host.classList.add('is-drawn'); return; }
    p.style.strokeDasharray = '1 1';
    var a = animate(p, [{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], { duration: YK.T.draw, delay: delay || 0, easing: YK.E.out, fill: 'both' });
    var finish = function () { p.style.strokeDasharray = 'none'; p.style.strokeDashoffset = '0'; if (host) host.classList.add('is-drawn'); };
    if (a && a.finished) a.finished.then(function () { finish(); try { a.cancel(); } catch (e) {} }, function () {}); else finish();
  };
  YK.hideLine = function (svg) {
    var p = svg.localName === 'path' ? svg : svg.querySelector('path'); if (!p) return;
    p.setAttribute('pathLength', '1'); p.style.strokeDasharray = '1 1'; p.style.strokeDashoffset = 1;
    var host = svg.closest ? svg.closest('[data-yn-draw]') : null; if (host) { host.classList.remove('is-drawn'); host.__ynDr = false; }
  };
  YK.pop = function (el, big) { if (!el || !YK.ok('answer')) return; animate(el, [{ transform: 'scale(1)' }, { transform: 'scale(' + (big || 1.3) + ')' }, { transform: 'scale(1)' }], { duration: 360, easing: YK.E.spring }); };
  YK.press = function (el) { if (el && YK.ok('answer')) animate(el, [{ transform: 'scale(1)' }, { transform: 'scale(.97)' }, { transform: 'scale(1)' }], { duration: 240, easing: YK.E.spring }); };
  YK.shake = function (el, px) {
    if (!el || !YK.ok('answer')) return;
    var d = px || 3;
    animate(el, [{ transform: 'translateX(0)' }, { transform: 'translateX(' + -d + 'px)' }, { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(' + -d + 'px)' }, { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(0)' }], { duration: 320, easing: 'ease-in-out' });
  };
  YK.stamp = function (el, delay) {
    if (!el || !YK.ok('up')) return;
    animate(el, [{ transform: 'scale(1.6) rotate(-14deg)', opacity: 0 }, { transform: 'scale(.94) rotate(-1deg)', opacity: 1, offset: 0.7 }, { transform: 'scale(1) rotate(-2deg)', opacity: 1 }], { duration: 300, delay: delay || 0, easing: YK.E.out, fill: 'backwards' });
  };
  YK.boilText = function (el) { // short stepped jitter, like a fresh drawing
    if (!el || !YK.ok('up')) return;
    var k = [], f = ['translate(0,0) rotate(0deg)', 'translate(.6px,-.4px) rotate(-.5deg)', 'translate(-.5px,.5px) rotate(.4deg)', 'translate(.4px,.3px) rotate(-.3deg)'];
    for (var i = 0; i < 6; i++) k.push({ transform: f[(i % 3) + 1], easing: 'steps(1,end)' });
    k.push({ transform: f[0] });
    animate(el, k, { duration: 750 });
  };
  YK.countTo = function (el, from, to, fmt, dur) {
    if (!el) return;
    fmt = fmt || function (n) { return String(Math.round(n)); };
    if (!YK.ok('answer')) { el.textContent = fmt(to); return; }
    var t0 = performance.now(), D = dur || 400;
    var tick = function (t) {
      var u = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - u, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (u < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  YK.fly = function (fromEl, toEl, src) { // fly-to-cart arc, ~450ms, in viewport coordinates (the 4th argument of the prototype is ignored)
    if (!fromEl || !toEl || !src || !YK.ok('up')) return Promise.resolve();
    var a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect();
    if (!a.width || !b.width) return Promise.resolve();
    var S = 56;
    var img = doc.createElement('img');
    img.alt = ''; img.src = src; img.decoding = 'async';
    var st = img.style;
    st.position = 'fixed'; st.margin = '0'; st.maxWidth = 'none';
    st.left = a.left + a.width / 2 - S / 2 + 'px'; st.top = a.top + a.height / 2 - S / 2 + 'px';
    st.width = S + 'px'; st.height = S * 1.25 + 'px'; st.objectFit = 'cover'; st.borderRadius = '12px';
    st.zIndex = '1300'; st.pointerEvents = 'none'; st.boxShadow = '0 8px 20px rgba(31,42,68,.25)';
    doc.body.appendChild(img);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var lift = Math.min(-60, dy * 0.5 - 80);
    var an = animate(img, [
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + lift + 'px) scale(.8) rotate(-8deg)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25) rotate(4deg)', opacity: 0.6 }
    ], { duration: 450, easing: 'cubic-bezier(.4,.1,.6,1)', fill: 'forwards' });
    return done(an).then(function () { img.remove(); });
  };
  YK.burst = function (layer, x, y) { // 14 hand-drawn bits, <= 800ms; x and y are viewport coordinates (layer is ignored)
    if (!YK.ok('charm')) return;
    var cols = ['#fece00', '#0040ea', '#f49ac1', '#1f9a5b', '#ff6a1a'];
    for (var i = 0; i < 14; i++) {
      var s = doc.createElement('span'), a = (i / 14) * 6.283 + Math.random() * 0.4, r = 40 + Math.random() * 40;
      var st = s.style;
      st.position = 'fixed'; st.left = x + 'px'; st.top = y + 'px'; st.width = '8px'; st.height = i % 3 ? '8px' : '3px';
      st.borderRadius = i % 3 === 1 ? '50%' : '2px'; st.background = cols[i % 5]; st.zIndex = '1300'; st.pointerEvents = 'none';
      doc.body.appendChild(s);
      (function (el, ang, rad, n) {
        done(animate(el, [{ transform: 'translate(0,0) rotate(0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(ang) * rad + 'px,' + Math.sin(ang) * rad + 'px) rotate(' + (200 + n * 20) + 'deg) scale(.6)', opacity: 0 }], { duration: 760, easing: YK.E.out })).then(function () { el.remove(); });
      })(s, a, r, i);
    }
  };
  YK.land = function (els) { // cards land with a small tilt and settle
    if (!YK.ok('charm')) return;
    Array.prototype.forEach.call(els || [], function (el, i) {
      animate(el, [{ opacity: 0, transform: 'translateY(16px) rotate(-2.5deg)' }, { opacity: 1, transform: 'translateY(-2px) rotate(.6deg)', offset: 0.7 }, { opacity: 1, transform: 'none' }], { duration: 420, delay: Math.min(i, 6) * 40, easing: YK.E.out, fill: 'backwards' });
    });
  };

  /* ------------------------------------------------------------ reveal on scroll (once per section) */
  function skipEl(el) {
    var t = el.localName;
    return t === 'script' || t === 'style' || t === 'template' || t === 'link' || el.hasAttribute('hidden') || el.hasAttribute('data-yn-noreveal') ||
      el.hasAttribute('data-yn-sheet') || (el.classList && el.classList.contains('yn-sheet'));
  }
  // The pieces that arrive: every [data-yn-stagger] element; unmarked pieces that sit beside them (the title, a button) arrive too.
  function revealItems(sec) {
    var out = [];
    (function walk(node) {
      for (var i = 0; i < node.children.length; i++) {
        var c = node.children[i];
        if (skipEl(c)) continue;
        if (c.hasAttribute('data-yn-stagger')) out.push(c);
        else if (c.querySelector('[data-yn-stagger]')) walk(c);
        else out.push(c);
      }
    })(sec);
    return out;
  }
  function framesOf(sec) { return qa(sec, '[data-yn-frame]').filter(function (f) { return !f.closest('[data-yn-noreveal]'); }); }
  function trigger(sec, items, immediate) {
    sec.setAttribute('data-yn-rv', 'done');
    var lines = qa(sec, '[data-yn-draw]'), frames = framesOf(sec);
    if (!immediate) {
      items.forEach(function (el, i) {
        el.style.opacity = '';
        animate(el, [{ opacity: 0, translate: '0 12px' }, { opacity: 1, translate: '0 0' }], { duration: YK.T.base + 80, delay: Math.min(i, 6) * 40, easing: YK.E.out, fill: 'backwards' });
      });
    }
    lines.forEach(function (l) { YK.drawLine(l, immediate ? 150 : 60); });
    frames.forEach(function (f, i) { F.draw(f, (immediate ? 150 : 0) + Math.min(i, 6) * 40); });
    var ev;
    try { ev = new CustomEvent('yk-reveal'); sec.dispatchEvent(ev); ev = new CustomEvent('yn-reveal'); sec.dispatchEvent(ev); } catch (e) {}
  }
  function setupReveal(sec) {
    if (sec.__ynRv) return; sec.__ynRv = true;
    var r = sec.getBoundingClientRect();
    var visibleNow = r.height > 0 && r.top < win.innerHeight * 0.75 && r.bottom > 0;
    var plain = !YK.ok('charm') || designMode;
    framesOf(sec).forEach(function (f) { if (!plain) F.hide(f); });
    qa(sec, '[data-yn-draw]').forEach(function (l) { if (!plain) YK.hideLine(l); });
    if (plain) { trigger(sec, [], true); return; }
    if (r.width === 0 && r.height === 0) { trigger(sec, [], true); return; }   // not rendered (inside a closed tab or sheet): nothing to wait for
    if (visibleNow) { trigger(sec, [], true); return; }                          // already on screen at load: no entrance, the lines still draw
    var items = revealItems(sec);
    sec.setAttribute('data-yn-rv', 'pending');
    items.forEach(function (el) { el.style.opacity = '0'; });
    if (!('IntersectionObserver' in win)) { trigger(sec, items, false); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.intersectionRatio < 0.18 && e.intersectionRect.height < 140) return;
        io.disconnect();
        trigger(sec, items.filter(function (el) { return el.isConnected; }), false);
      });
    }, { threshold: [0, 0.05, 0.1, 0.18, 0.3] });
    io.observe(sec);
  }
  YK.reveal = function (root) { qa(root || doc, '[data-yn-reveal]').forEach(setupReveal); };

  /* ------------------------------------------------------------ draw-on for lines and frames outside a reveal section; badge stamps */
  function inPendingReveal(el) {
    var sec = el.closest('[data-yn-reveal]');
    return !!sec && sec.getAttribute('data-yn-rv') === 'pending';
  }
  function whenVisible(el, fn, threshold) {
    if (!('IntersectionObserver' in win)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } });
    }, { threshold: threshold || 0.4 });
    io.observe(el);
  }
  function setupDraw(el) {
    if (el.__ynD) return; el.__ynD = true;
    var sec = el.closest('[data-yn-reveal]');
    if (sec) { if (sec.getAttribute('data-yn-rv') === 'done') YK.drawLine(el, 60); return; }   // a pending section draws it when it reveals
    if (!YK.ok('charm')) { YK.drawLine(el); return; }
    YK.hideLine(el);
    var delay = +el.getAttribute('data-yn-delay') || 120;
    whenVisible(el, function () { YK.drawLine(el, delay); }, 0.5);
  }
  function setupFrame(host) {
    if (host.__ynFd) return; host.__ynFd = true;
    var sec = host.closest('[data-yn-reveal]');
    if (sec) {
      var rv = sec.getAttribute('data-yn-rv');
      if (rv === 'done') { if (host.__drawn !== true) F.draw(host, 0); }
      else if (rv === 'pending' && !host.closest('[data-yn-noreveal]') && host.__drawn !== false) F.hide(host);
      return;
    }
    if (!YK.ok('charm') || host.closest('[data-yn-noreveal]')) { F.draw(host); return; }
    F.hide(host);
    whenVisible(host, function () { F.draw(host, 0); }, 0.25);
  }
  var stamped = {};
  var badgeIO = null;
  function observeBadges(root) {
    var list = qa(root, '.yn-badge--sale');
    if (!list.length || !('IntersectionObserver' in win)) return;
    if (!badgeIO) badgeIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        badgeIO.unobserve(e.target);
        var card = e.target.closest('[data-handle]'), id = card ? card.getAttribute('data-handle') : null;
        if (id) { if (stamped[id]) return; stamped[id] = 1; }
        YK.stamp(e.target, 120);
      });
    }, { threshold: 0.6 });
    list.forEach(function (b) { if (b.__ynB) return; b.__ynB = true; badgeIO.observe(b); });
  }

  /* ------------------------------------------------------------ hydrate: icons, frames, buddies, reveal, lines, badges (idempotent) */
  var SEL = '[data-yn-icon],[data-yn-frame],[data-yn-buddy],[data-yn-reveal],[data-yn-draw],.yn-badge--sale';
  YK.hydrate = function (root) {
    root = root || doc;
    qa(root, '[data-yn-icon]').forEach(function (el) {
      var k = el.getAttribute('data-yn-icon') + '|' + (el.getAttribute('data-size') || '');
      if (el.__ic === k) return; el.__ic = k;
      el.innerHTML = YK.icon(el.getAttribute('data-yn-icon'), +el.getAttribute('data-size') || 24);
    });
    qa(root, '[data-yn-frame]').forEach(F.mount);
    qa(root, '[data-yn-buddy]').forEach(B.mount);
    YK.reveal(root);
    qa(root, '[data-yn-draw]').forEach(setupDraw);
    qa(root, '[data-yn-frame]').forEach(setupFrame);
    observeBadges(root);
  };

  function boot() {
    YK.hydrate(doc);
    if ('MutationObserver' in win) {
      var pending = [], queued = false;
      new MutationObserver(function (muts) {
        muts.forEach(function (m) { for (var i = 0; i < m.addedNodes.length; i++) { var n = m.addedNodes[i]; if (n.nodeType === 1) pending.push(n); } });
        if (!pending.length || queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          var batch = pending.splice(0);
          batch.forEach(function (n) { if (n.isConnected && (n.matches(SEL) || n.querySelector(SEL))) YK.hydrate(n); });
        });
      }).observe(doc.body || doc.documentElement, { childList: true, subtree: true });
    }
  }

  YK.ready = true;
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  try { doc.dispatchEvent(new Event('yk-ready')); } catch (e) {}
})();
